module.exports = __webpack_public_path__ + "static/media/warzone.8aff1e43.webp";